import React from "react";
import { IconsType } from "../../libs/Utils/types";
function Add({width, height}:IconsType) {
  return (
    <div  style={{width, height}}>
      <svg
       
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 1.5V9M9 16.5V9M9 9H16.5M9 9H1.5"
          stroke="#D52B1E"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

export default Add;
